import React from 'react';
import { Box, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';

import ProductDetailsTitle from '../components/ProductDetailsPage/ProductDetailsTitle';
import FeaturesGrid from '../components/ProductDetailsPage/FeaturesGrid';
import ContentSection from '../components/ProductDetailsPage/ContentSection';
import SolutionsGrid from '../components/AboutUsPage/SolutionsGrid';
import ContactCTA from '../components/AboutUsPage/ContactCTA';

const ProductDetailsPage = () => {
  const location = useLocation();
  const { title, description, image, features } = location.state || {};
  return (
    <Box>
      <ProductDetailsTitle title={title} />
      <Container maxWidth="lg">
        <FeaturesGrid />
        <ContentSection description={description} features={features} />
      </Container>
      <SolutionsGrid />
      <ContactCTA />
    </Box>
  );
};

export default ProductDetailsPage; 